import axios from "./index";

let base = "";

class CompetitorApi {
  // دریافت لیست رقبا
  static Competitors = () => {
    return axios.get(`${base}/competitors`);
  };

  // جستجو در محصولات رقیب
  static CompetitorsSearch = (payload = {}) => {
    return axios.get(`${base}/competitors/search`, payload);
  };

  // مپ کردن (وصل کردن) ویژگی‌های محصول ما به محصول رقیب
  static MapAttributes = (payload) => {
    return axios.post(`${base}/competitors/map-attributes`, payload);
  };

  // همگام‌سازی (سینک) دستی قیمت‌های یک محصول خاص
  static SyncPrices = (payload) => {
    return axios.post(`${base}/competitors/sync-prices`, payload);
  };

  static RemoveMapping = (id) => {
    return axios.delete(`${base}/competitors/map-attributes/${id}`);
  };
}

export default CompetitorApi;